var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9362_48437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9362_48437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 14H7.83301V10H6.33301V14ZM12.833 14H14.333V6H12.833V14ZM9.58301 14H11.083V11H9.58301V14ZM9.58301 10H11.083V8.5H9.58301V10ZM4.83301 17C4.42051 17 4.06738 16.8531 3.77363 16.5594C3.47988 16.2656 3.33301 15.9125 3.33301 15.5V4.5C3.33301 4.0875 3.47988 3.73438 3.77363 3.44063C4.06738 3.14688 4.42051 3 4.83301 3H15.833C16.2455 3 16.5986 3.14688 16.8924 3.44063C17.1861 3.73438 17.333 4.0875 17.333 4.5V15.5C17.333 15.9125 17.1861 16.2656 16.8924 16.5594C16.5986 16.8531 16.2455 17 15.833 17H4.83301ZM4.83301 15.5H15.833V4.5H4.83301V15.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.59d57d14c51023de1ca9a3328bdadf15.svg";
export { ForwardRef as ReactComponent };